import { Message, MessageLevel } from '@lp/lp-ui';
import {
    ApiViewResponseError, InviteUserRequestModel, UserDataModel, UserInvitationSummaryModel
} from '../../typings';

export type InvitationState = 'none' | 'not-sent' | 'not-delivered' | 'expired' | 'live';

// `invited` is the server's verdict (unaccepted invitation on an enabled user). A disabled user
// still carries a summary, so the summary alone must never light the chip or the Resend action.
// Absent fields arrive as undefined, never null, so every check here is a falsy check.
export const invitationState = (
    invited: boolean,
    invitation: UserInvitationSummaryModel | null | undefined,
    now: Date = new Date()
): InvitationState => {
    if (!invited || !invitation) return 'none';
    if (!invitation.sentUtc) return 'not-sent';
    // Ahead of expiry: an invitee who never received a link needs an admin more than one whose
    // link merely aged out. No link at all still outranks both.
    if (invitation.lastDeliveryFailedUtc) return 'not-delivered';
    if (invitation.expiresUtc && new Date(invitation.expiresUtc) < now) return 'expired';
    return 'live';
};

// The assignment panels write into UserDataModel; the invite endpoint accepts this subset of it.
export const toInviteUserRequestModel = (data: UserDataModel): InviteUserRequestModel => ({
    email: data.email,
    twoFactorEnabled: data.twoFactorEnabled,
    userClients: data.userClients,
    roleIds: data.roleIds,
    userOrganizations: data.userOrganizations
});

export const toErrorMessages = (errors: ApiViewResponseError[]): Message[] =>
    errors.map(e => ({ details: e.detail, level: MessageLevel.Error }));
